<template>
    <div id="searchBg">

        <div class="searchcontainer">
            <div class="searchHeader">
                <div>
                    <el-input placeholder="请输入内容" v-model="search" class="input-with-select" style="width: 700px;"
                        @keyup.enter.native="searchContent">
                        <!-- <el-button slot="append" icon="el-icon-search"></el-button> -->
                        <el-button class="searchbutton" slot="append" type="danger" @click="searchContent">搜索</el-button>
                    </el-input>
                    <el-input style="display:none"></el-input>
                </div>
                <div class="searchtype">
                    <ul>
                        <li v-for="(item, index) in searchtype" v-show="index !== 4" :key="item"
                            :class="chooseType == index ? 'active' : ''" @click="() => {
                                chooseType = index;
                                page = 1;
                                size = 5;
                                searchContent();
                            }">
                            {{ item }}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="searchlist">
                <p class="searchNumber">
                    为您找到 {{ total }} 条搜索结果
                </p>
                <div class="list">
                    <ul v-if="total !== 0">
                        <li v-for="(item, index) in searchlist" :key="index" @click="openNewtab(item)">
                            <!-- <p>{{ item.title }}</p> -->
                            <p v-html="item.title"></p>
                            <!-- <p>{{ item.type == 3 || item.type == 5 ? item.content : item.summary }}
                            </p> -->
                            <p v-html="item.summary"></p>
                            <p>来自： {{ item.className }}</p>
                        </li>
                    </ul>
                    <el-empty v-else style="width: 1100px;" description="未查询到您输入的内容"></el-empty>
                    <div class="righthotpot">
                        <p>
                            产品推荐
                        </p>
                        <ul>
                            <li v-for="(item, index) in hotpotlist" :key="item" @click="hotpotClick(item)">
                                {{ item }}
                            </li>
                        </ul>
                    </div>
                </div>
                <el-pagination :page-size="size" :current-page="page + 1" style="margin-top:60px" background
                    layout="prev, pager, next" :total="total" @current-change="changePage" hide-on-single-page>
                </el-pagination>
            </div>

        </div>
        <div class="searchbg">
        </div>
    </div>
</template>
<script>
import { searchArticle } from '@/api'
export default {
    name: 'Search',
    data() {
        return {
            hotpotlist: ['一网统管', '垃圾分类', '集团管控', '收运系统'],
            searchtype: ['全部', '产品服务', '解决方案', ' 平台资讯', '关于平台', '开放文档'],
            searchlist: [],
            search: null,
            page: 0,
            size: 5,
            chooseType: 0,
            total: 0,
        }
    },
    mounted() {
        this.getSearchlist();
    },
    methods: {
        async getSearchlist() {
            const { data } = await searchArticle({
                type: this.chooseType,
                page: this.page,
                size: this.size,
                keyword: this.search
            });
            const list = data.content.map(v => {
                v.className = v.className.replace("|", ">")
                return v
            })
            this.total = data.totalElements;
            this.searchlist = list;

        },
        searchContent(type) {
            if (type == 1) {
            } else {
                this.page = 0;
            };
            this.getSearchlist();
        },
        openNewtab(item) {
            window.open(item.url)
        },
        changePage(page) {
            this.page = page - 1;
            this.searchContent(1);
        },
        hotpotClick(item) {
            this.search = item;
            // this.search = '测';
            this.searchContent();
        }
    },
    created() {
        this.search = this.$route.query.searchcontent || ''
        if (this.search !== '') {
            this.searchContent()
        }

    },
    watch: {
        $route: {
            handler(newVal, oldVal) {
                this.search = String(newVal.query.searchcontent)
                this.searchContent();
            },
            deep: true
        }

    }
}
</script>
<style lang="scss" scope>
* {
    margin: 0;
    padding: 0;
}

ul {
    list-style: none;

    li {
        display: inline-block;
    }
}

#searchBg {
    // text-align: center;
    padding-top: 64px;
    width: 100%;
    // height: 100vh;
    min-height: 600px;
    background-position: center;
    position: relative;

    .searchbg {
        width: 100%;
        height: 170px;
        background: url(../assets/images/searchbg.png);
        background-size: 100% 100%;
        position: absolute;
        top: 64px;
        left: 0;
        z-index: 0;
    }

    .searchcontainer {
        z-index: 1000;
        position: relative;
        width: 1400px;
        padding-top: 40px;
        margin: 0 auto;

        .searchbutton {
            background-color: #D7000F !important;
            color: #fff;
            width: 100px;
            border-radius: 0 4px 4px 0;
        }

        .hotpot {
            margin-top: 8px;
            z-index: 1000;
            margin-bottom: 16px;

            ul {
                li {
                    margin-right: 15px;
                    cursor: pointer;
                    color: #333;

                    &:hover {
                        color: #D7000F;
                    }
                }
            }
        }

        .searchtype {
            margin-top: 40px;

            ul {
                li {
                    cursor: pointer;
                    width: 104px;
                    line-height: 40px;
                    font-weight: 400;
                    margin-right: 34PX;
                    position: relative;

                    &.active {
                        color: #D7000F;

                        &::before {
                            position: absolute;
                            left: 0px;
                            bottom: 0px;
                            content: "";
                            width: 100%;
                            height: 3px;
                            background-color: #D7000F;
                        }
                    }
                }
            }
        }

        .searchlist {
            width: 100%;

            .searchNumber {
                margin: 32px 0;
            }

            .list {
                display: flex;
                justify-content: space-between;
                .highlight {
                    color: #D7000F;
                }
                ul {
                    width: 1100px;

                    &:first-child {
                        li {
                            padding: 10px;
                            border-radius: 4px;

                            &:hover {
                                background-color: #f4f8fe;

                            }
                        }
                    }

                    li {
                        width: 100%;
                        margin-bottom: 10px;
                        cursor: pointer;

                        p {
                            &:first-child {
                                color: #333;
                                font-size: 20px;
                                font-style: normal;
                                font-weight: 600;
                                line-height: 30px;
                                overflow: hidden;
                                white-space: nowrap;
                                /* 防止文字换行 */
                                text-overflow: ellipsis;
                                /* 150% */
                            }

                            &:nth-child(2) {
                                color: #595959;
                                font-size: 14px;
                                font-style: normal;
                                font-weight: 400;
                                line-height: 20px;
                                /* 142.857% */
                                display: -webkit-box;
                                text-overflow: ellipsis;
                                overflow: hidden;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 2;
                            }

                            &:nth-child(3) {
                                color: var(---999, #999);
                                font-size: 14px;
                                font-style: normal;
                                font-weight: 400;
                                line-height: 20px;
                                /* 142.857% */
                            }
                        }
                    }
                }

                .righthotpot {
                    width: 260px;

                    p {
                        color: #262626;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 300;
                        line-height: 30px;
                        /* 187.5% */
                    }

                    // background-color: red;
                    ul {
                        width: 100%;

                        li {
                            width: 100%;
                            cursor: pointer;

                            &:hover {
                                color: #D7000F;
                            }
                        }
                    }
                }
            }
        }



    }
}
</style>


// WEBPACK FOOTER //
// src/components/Search.vue